import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { ContextoService } from '@core/services/contexto.service';
import { esRolAdmin } from '@core/constants/roles.constants';
import { MODOS_SISTEMA } from '@core/constants/modos.constants';

const RUTA_ADMINISTRACION = 'administracion';
const RUTA_ACCESO_DENEGADO = '/acceso-denegado';


export const seguridadGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const contextoService = inject(ContextoService);
  const router = inject(Router);

  const rutaActual = (route.url || []).map(segment => segment.path).join('/');
  const esRutaAdmin = rutaActual.startsWith(RUTA_ADMINISTRACION) || 
                      (route.pathFromRoot || []).some(r => 
                        (r.url || []).some(segment => segment.path === RUTA_ADMINISTRACION)
                      );

  if (esRutaAdmin) {
    const orgIdActual = contextoService.obtenerOrgIdActual();
    const modoActual = contextoService.obtenerModoActual();
    
    const orgRolesJWT = contextoService.obtenerOrgRolesJWT() || [];
    
    const tieneRolAdminEnJWT = orgRolesJWT.some(
      orgRol => 
        (orgIdActual === null || orgRol.orgId === orgIdActual) &&
        esRolAdmin(orgRol.role)
    );
    
    const esModoAdmin = modoActual === MODOS_SISTEMA.ADMIN;

    if (!tieneRolAdminEnJWT || !esModoAdmin) {
      void router.navigate([RUTA_ACCESO_DENEGADO]);
      return false;
    }
  }

  return true;
};
